import moment from "moment";
import "moment/locale/fr-ca";

// Calendrier de diffusion du commerce international et de
const CALENDARS = {
  // Mettre à jour les dates prévues de mises à jour autour de février-mars de chaque année. Se baser sur le calendrier de diffusion ISQ.
  ISQ: [
    "2025-10-21",
    "2025-12-22",
    "2026-01-22",
    "2026-02-12",
    "2026-03-10",
    "2026-03-27",
    "2026-04-21",
    "2026-05-20",
    "2026-06-23",
    "2026-07-21",
    "2026-08-18",
    "2026-09-18",
    "2026-10-21",
    "2026-11-18",
    "2026-12-21",
    "2027-01-20",
    "2027-02-23",
  ],
  // Communiqués économiques principaux : https://www150.statcan.gc.ca/n1/dai-quo/cal1-fra.htm, voir PDF.
  STATCAN: [
    "2026-02-19",
    "2026-03-12",
    "2026-04-02",
    "2026-05-05",
    "2026-06-09",
    "2026-07-07",
    "2026-08-04",
    "2026-09-03",
    "2026-10-06",
    "2026-11-04",
    "2026-12-08",
    "2027-01-06",
    "2027-02-04",
  ],
};

export default {
  dateToString(date, lang = "fr", format = "MMMM YYYY") {
    if (date && lang) {
      return moment(date).locale(lang).format(format);
    }

    return lang === "en" ? "Not available" : "Non disponible";
  },
  /**
   * Récupérer la date de mise à jour du calendrier en paramètre (ISQ ou STATCAN) la plus récente basée sur la date de référence en paramètre.
   * @param {"ISQ"|"STATCAN"} [calendar="ISQ"] Calendrier de dates à interroger (défaut "ISQ")
   * @param {moment.Moment} [dateReference] Date de référence facultative utilisée comme borne (défaut "date du jour")
   */
  getLatestDateFromCalendarSince(calendar, dateReference) {
    const CALENDAR = CALENDARS[calendar];
    const reference =
      moment.isMoment(dateReference) || moment.isDate(dateReference)
        ? moment(dateReference)
        : moment();
    let derniereDate = null;

    for (let i = 0; i < CALENDAR.length; i++) {
      const date = moment(CALENDAR[i]);
      if (date.isSameOrBefore(reference, "day")) {
        derniereDate = date;
      }
      // date dépassée, fin boucle
      else {
        break;
      }
    }
    return derniereDate;
  },
};
